<template>
  <div class="pt-4" :class="{ 'px-4': $vuetify.breakpoint.mdAndUp }">
    <Breadcrumbs
      :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
      :headline="this.$options.filters.getGradeTitle(grade)"
      :link="[
        { text: 'Học phần', href: '../grades' },
        { text: this.$options.filters.getGradeTitle(grade), id: grade.id },
      ]"
    />
    <Overview :grade="grade" />
    <ConfigTabs class="mt-8" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import { mapActions, mapState } from 'vuex'
import Overview from '../../modules/grade/detail/Overview.vue'
import ConfigTabs from '../../modules/grade/detail/ConfigTabs.vue'

export default {
  components: { Breadcrumbs, Overview, ConfigTabs },
  computed: {
    ...mapState('grade', ['grade']),
  },
  async created() {
    await this.fetchOneGrade(this.$route.params.id)
  },
  methods: {
    ...mapActions({
      fetchOneGrade: 'grade/fetchOneGrade',
    }),
  },
  filters: {
    getGradeTitle(grade) {
      if (!grade) return '--'
      return `${grade.code} - ${grade.title}`
    },
  },
}
</script>
